import React from "react";
import PagePlaceholder from "../components/PagePlaceholder";

const ReportesView = () => <PagePlaceholder title="Reportes" />;

export default ReportesView;
